import React from 'react';
import ErrorIcon from '../_content/images/icons/error.svg';
import AlertIcon from '../_content/images/icons/alert.svg';
import { CaseType } from '../type/enums';
import useTranslate from '../languages/useTranslate';

const useGetCaseConfig = (caseType: CaseType, caseButtons: React.FC[]) => {
    const translate = useTranslate('addPayee.confirmationOfPayee');
    const [CancelButton, ChangePayeeButton, ProceedAnywayButton] = caseButtons;

    const Buttons = [CancelButton, ChangePayeeButton, ProceedAnywayButton];
    const PartialButtons = [CancelButton, ProceedAnywayButton];

    const config = {
        ANNM: {
            icon: ErrorIcon,
            title: translate("ANNM.title"),
            text: translate("ANNM.subText"),
            buttons: Buttons,
        },
        OPTO: {
            icon: ErrorIcon,
            title: translate("OPTO.title"),
            text: translate("OPTO.subText"),
            buttons: PartialButtons,
        },
        CASS: {
            icon: ErrorIcon,
            title: translate("CASS.title"),
            text: translate("CASS.subText"),
            buttons: PartialButtons,
        },
        AC01: {
            icon: ErrorIcon,
            title: translate("AC01.title"),
            text: translate("AC01.subText"),
            buttons: [CancelButton],
        },
        SCNS: {
            icon: ErrorIcon,
            title: translate("AC01.title"),
            text: translate("AC01.subText"),
            buttons: [CancelButton],
        },
        IVCR: {
            icon: ErrorIcon,
            title: translate("IVCR.title"),
            text: translate("IVCR.subText"),
            buttons: PartialButtons,
        },
        ACNS: {
            icon: ErrorIcon,
            title: translate("ACNS.title"),
            text: translate("ACNS.subText"),
            buttons: PartialButtons,
        },
        PAMM: {
            icon: AlertIcon,
            title: translate("PAMM.title"),
            text: translate("PAMM.subText"),
            buttons: Buttons,
        },
        MBAM: {
            icon: AlertIcon,
            title: translate("MBAM.title"),
            text: '',
            buttons: PartialButtons,
        },
        BANM: {
            icon: AlertIcon,
            title: translate("BANM.title"),
            text: '',
            buttons: PartialButtons,
        },
        PANM: {
            icon: AlertIcon,
            title: translate("BANM.title"),
            text: '',
            buttons: PartialButtons,
        },
        BAMM: {
            icon: AlertIcon,
            title: translate("BAMM.title"),
            text: '',
            buttons: Buttons,
        },
        E500: {
            icon: ErrorIcon,
            title: translate("E500.title"),
            text: translate("E500.subText"),
            buttons: Buttons,
        }
    };

    return config[caseType] || null;
}

export default useGetCaseConfig;